import { rest } from 'msw';
import { getConfig } from 'shared/config';
import {
  blandselvAccessOwner,
  communicationsMock,
  netflixInfo,
  tvSubscription,
  tvSubscriptionDetails,
  tvSubscriptionOverview,
  tvSubscriptionWithMixedTv,
} from '.';

const odinAPI = getConfig().odin?.host;

export const handlers = [
  rest.get(`${odinAPI}/yousee/selfcare/products/MOCK_TV/menu-details`, (req, res, ctx) =>
    res(ctx.json(tvSubscriptionDetails)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/subscriptions/MOCK_TV`, (req, res, ctx) =>
    res(ctx.json(tvSubscriptionWithMixedTv)),
  ),
  // Test TV URL as test_030320: https://l-selfcare.yousee.dk/tv/87837768814585B368E3A5DD6ED29CD3,SP11_012_01_TV
  rest.get(
    `${odinAPI}/yousee/selfcare/subscriptions/87837768814585B368E3A5DD6ED29CD3`,
    (req, res, ctx) => res(ctx.json(tvSubscription)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/tv/:subscriptionId/productsoverview`, (req, res, ctx) =>
    res(ctx.json(tvSubscriptionOverview)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/tv/:subscriptionId/communications`, (req, res, ctx) =>
    res(ctx.json(communicationsMock)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/tv/:subscriptionId/netflixInfo`, (req, res, ctx) =>
    res(ctx.json(netflixInfo)),
  ),
  rest.get(
    `${odinAPI}/yousee/selfcare/tv/:subscriptionId/channels-and-packages/blandselv/access-owner`,
    (req, res, ctx) => res(ctx.json(blandselvAccessOwner)),
  ),
  rest.put(
    `${odinAPI}/yousee/selfcare/tv/:subscriptionId/channels-and-packages/blandselv/:productCode`,
    (req, res) => res(),
  ),
];
